import { useMutation } from '@tanstack/react-query'

import { createPurchaseApplicationTemplate } from '@src/api'
import { useAxios } from '@src/hooks/use-axios'

import { MutationCreatePurchaseApplicationTemplateArgs } from './type'

export const useCreateTemplate = () => {
  const { axiosInstance } = useAxios()
  return useMutation({
    mutationFn: ({
      params,
      organizationId,
    }: MutationCreatePurchaseApplicationTemplateArgs) =>
      createPurchaseApplicationTemplate(axiosInstance, {
        organizationId,
        createPurchaseApplicationTemplateRequest: params,
      }),
  })
}
